import { createStore } from '@shared/store';
import { UserDetailsType } from '@shared/types';
import {
  ServiceLocationDetailsObjectType,
  BinaryOptionsType,
  GulliesAsset,
  CaseIDProps,
} from '@types';

type ServiceLocationDetailsType = ServiceLocationDetailsObjectType & {
  additional_details?: string;
};

export type DrainIssueType =
  | 'BlockedDrain'
  | 'BrokenDrainCover'
  | 'BurstWaterMain'
  | 'Flooding'
  | 'MissingDrainCover'
  | 'SmellyDrain'
  | 'SomethingElse'
  | string
  | undefined;

export type FloodingType = 'Road' | 'Footpath' | '';

const initialData = {
  uploadedImages: [],
  uploadedImagesFileName: [],
  uploadedImagesFileType: [],
  uploadedImagesBlob: [],
  serviceLocationDetailsFromFile:
    [] as unknown as ServiceLocationDetailsObjectType,
  serviceLocationDetails: [] as unknown as ServiceLocationDetailsType,
  assetDetails: null,
  fileWithLoadedCoordinates: '',
  isPhotoLocationStored: false,
  issueLocationMoreInfo: '',
  wantConfirmationEmail: '' as BinaryOptionsType,
  contactUserOption: '',
  caseReferenceId: '',
  slaText: '',
  userDetails: {
    firstName: '',
    lastName: '',
    email: '',
    contactId: '',
  },
  sessionId: '',
  issueType: '' as DrainIssueType,
  isHazardous: '' as BinaryOptionsType,
  isIssuePrivateProperty: '' as BinaryOptionsType | 'DontKnow',
  floodType: '' as FloodingType,
  tellUsMoreDetails: '',
  fileDetailsObjects: [],
  issueLocationType: null,
  confirmation: undefined,
};

interface useDrainsStoreType {
  uploadedImages: string[];
  uploadedImagesFileName: string[];
  uploadedImagesFileType: string[];
  uploadedImagesBlob: {
    blob_uri: string;
    blob_endpoint: string;
    filename: string;
  }[];
  serviceLocationDetailsFromFile: ServiceLocationDetailsObjectType;
  serviceLocationDetails: ServiceLocationDetailsType;
  assetDetails: GulliesAsset | null;
  fileWithLoadedCoordinates: string;
  isPhotoLocationStored: boolean;
  issueLocationMoreInfo: string;
  wantConfirmationEmail: BinaryOptionsType;
  contactUserOption: string;
  isHazardous: BinaryOptionsType;
  caseReferenceId: string;
  slaText: string;
  userDetails: UserDetailsType;
  sessionId: string;
  issueType: DrainIssueType;
  isIssuePrivateProperty: BinaryOptionsType | 'DontKnow';
  floodType: FloodingType;
  tellUsMoreDetails: string;
  fileDetailsObjects: { name: string; path: string }[];
  confirmation: CaseIDProps | undefined;
}

export const useDrainsStore = createStore<useDrainsStoreType>({
  initialData,
  name: 'drains-store',
  persist: true,
  enableDevTools: false,
});

/**
 * Function to reset user details
 * Note: use getState() to access Zustand store method outside of a React component
 * */
export const resetUserDetails = () => {
  useDrainsStore.getState().resetSelective(['userDetails', 'sessionId']);
};

export const resetIssueDetails = () => {
  useDrainsStore
    .getState()
    .resetSelective([
      'uploadedImages',
      'uploadedImagesFileName',
      'uploadedImagesFileType',
      'uploadedImagesBlob',
      'serviceLocationDetails',
      'fileWithLoadedCoordinates',
      'isPhotoLocationStored',
      'isHazardous',
      'issueLocationMoreInfo',
      'issueType',
      'isIssuePrivateProperty',
      'tellUsMoreDetails',
      'wantConfirmationEmail',
      'contactUserOption',
      'floodType',
      'assetDetails',
    ]);
};

export const updateStoreByKey = (key: string, value: any) => {
  useDrainsStore.getState().update(key as keyof useDrainsStoreType, value);
};
